import React from 'react';
import DENTModalOverviewPeriodontalItems from './DENTModalOverviewPeriodontalItems';
import { PeriodontalObject } from '../../Interfaces/PeriodontalObject.interface';
import styles from './DENTModalOverviewPeriodontalSelect.module.scss';
import DENTModalOverviewPeriodontalSelectMap from '../DENTModalOverviewPeriodontalSelectMap/DENTModalOverviewPeriodontalSelectMap';
import DENTModalOverviewPeriodontalSelectDiseases from './DENTModalOverviewPeriodontalSelectDiseases';

interface Props {
	periodontalObject: PeriodontalObject[];
}

const DENTModalOverviewPeriodontalSelect = ({ periodontalObject }: Props) => {
	return (
		<div className={styles.wrapper}>
			<DENTModalOverviewPeriodontalItems
				options={Object.values(periodontalObject)}
			/>
			<DENTModalOverviewPeriodontalSelectMap />
			<DENTModalOverviewPeriodontalSelectDiseases />
		</div>
	);
};

export default DENTModalOverviewPeriodontalSelect;
